import script from "./p9-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./p9-report-table.vue?vue&type=script&setup=true&lang=js"

import "./p9-report-table.vue?vue&type=style&index=0&id=8791e4fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8791e4fe"]])

export default __exports__